import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Auth } from "aws-amplify";

export const signInUser = createAsyncThunk("user/signInUser", async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (error) {
    console.log(error);

    throw error;
  }
});

const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    status: "idle",
    error: null,
    id: null,
    email: null,
    password: null,
    stripeId: null,
    managerName: null,
    managerImages: null,
  },
  reducers: {
    setId: (state, action) => {
      state.id = action.payload; // Action to set the id
    },
    setCreds: (state, action) => {
      state.email = action.payload.email;
      state.password = action.payload.password;
      state.stripeId = action.payload.stripeId;
    },
    setManagerInfo: (state, action) => {
      state.managerName = action.payload.name;
      state.managerImages = action.payload.images;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(signInUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.currentUser = action.payload;
      })
      .addCase(signInUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { setId, setCreds, setManagerInfo } = userSlice.actions;
export default userSlice.reducer;
